/**
 * A La Mode is a small accessibility compliant modal leveraging the HTML dialog element
 * This class is a global ModalManager that handles stacking and concurrency
 *
 * Specified and tested by Magnetic
 * Assisted-by: ChatGPT
 */

class AlmModalManager {
    constructor() {
        this.modals = new Map();
        this.stack = [];
        this.queue = [];
        this.isProcessingQueue = false;
    }

    register(id, modal) {
        this.modals.set(id, modal);
    }

    get(id) {
        return this.modals.get(id);
    }

    open(id, payload = {}) {
        const modal = this.get(id);
        if (!modal) return;

        // anti double open
        if (modal.isOpening) return;

        // si modal déjà ouverte → ignore ou replace
        if (this.stack.includes(modal)) {
            modal.focus();
            return;
        }

        // gestion concurrence
        if (this.stack.length > 0) {
            const active = this.stack[this.stack.length - 1];
            active.suspend();
        }

        this.stack.push(modal);

        modal.open(payload);
        this.emit('modal:open', { id, modal, payload });
    }

    close(id) {
        const modal = this.get(id);
        if (!modal) return;

        const index = this.stack.indexOf(modal);
        if (index === -1) return;

        this.stack.splice(index, 1);

        modal.close();

        const previous = this.stack[this.stack.length - 1];
        if (previous) {
            previous.resume();
        }

        this.emit('modal:close', { id, modal });
    }

    closeTop() {
        const top = this.stack[this.stack.length - 1];
        if (!top) return;

        this.close(top.id);
    }

    closeAll() {
        while (this.stack.length) {
            this.closeTop();
        }
    }

    enqueue(fn) {
        this.queue.push(fn);
        this.processQueue();
    }

    async processQueue() {
        if (this.isProcessingQueue) return;

        this.isProcessingQueue = true;

        while (this.queue.length) {
            const fn = this.queue.shift();
            await fn();
        }

        this.isProcessingQueue = false;
    }

    emit(name, detail) {
        document.dispatchEvent(new CustomEvent(name, { detail }));
    }
}

export const almModalManager = new AlmModalManager();
